import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import TextField, {
  TextFieldProps,
} from '../../../../../../../../shared/formElements/TextField';

export interface AdHocFreeTextFieldProps
  extends Omit<TextFieldProps<FieldValues>, 'type'> {}

export default function AdHocFreeTextField(props: AdHocFreeTextFieldProps) {
  const { name, ...textFieldProps } = props;

  const { t } = useTranslation();

  return (
    <TextField
      data-testid="delegate-ad-hoc-form-free-text-field"
      name={`${name}.__other__`}
      label={t('site.pricing.delegate.ad-hoc.form.field.free-text.label')}
      rules={{ required: true }}
      {...textFieldProps}
    />
  );
}
